import { render, staticRenderFns } from "./materialComponent.vue?vue&type=template&id=7c58b520&scoped=true&"
import script from "./materialComponent.vue?vue&type=script&lang=js&"
export * from "./materialComponent.vue?vue&type=script&lang=js&"
import style0 from "./materialComponent.vue?vue&type=style&index=0&id=7c58b520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c58b520",
  null
  
)

export default component.exports